import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../../../pages/order/models/orderModel';
import DeleteActionOrder from '../../../pages/order/actions/deleteAction';

export default class DeleteAction extends AttendeeAction {
    static NAME = 'delete';
    static ASYNCHRONOUS_LIMIT_MIN = 50;

    //only reserved and payed
    static condition(attendee) {
        return ['valid', 'reservation'].includes(attendee.order.status) && !attendee.removed && super.payment_plan_condition(attendee);
    }

    static is_attendee_valid({ attendee, order }) {
        return !attendee.removed;
    }

    run({ orders = null, attendees = null }) {
        if (orders) {
            //only not deleted
            const to_delete = orders.filter(o => DeleteActionOrder.condition(o));
            return Order.perform_action(DeleteActionOrder.NAME, to_delete, { organization: this.organization, event: this.event });
        }

        return Attendee.perform_action(this.constructor.NAME, attendees || this.filtered_items, { organization: this.organization, event: this.event }, this.isAsync(attendees));
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
